<template>
  <v-app>
    <Header :sidebar="true" @toggleDrawer="toggleDrawer"></Header>
    <ProjectDrawer ref="drawer"></ProjectDrawer>
    <v-main>
      <v-container fluid class="py-0 pb-3">
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from './components/Header'
import ProjectDrawer from './components/ProjectDrawer'

export default {
  name: 'ProjectLayout',
  components: {
    Header,
    ProjectDrawer
  },
  methods: {
    toggleDrawer () {
      this.$refs.drawer.toggleDrawer()
    }
  }
}
</script>
